let listopen = false;
import Swiper from 'swiper/bundle';

import isMobile from './helpers/mobile'
const build = () => {

    buildTesmonialsSlider();

    if (isMobile()) {
        buildContributorsMobile();


        $('.supporters .global .col-md-4').addClass('col-md-10');
        $('.supporters .global .col-md-4').removeClass('col-md-4');
        $('.supporters .global .col-md-6').addClass('col-md-10');
        $('.supporters .global .col-md-6').removeClass('col-md-6');
        $('.supporters .section-honor-roll .col-md-4').addClass('col-md-12');
        $('.supporters .section-honor-roll .col-md-8').addClass('col-md-12');
        $('.supporters .section-honor-roll .col-md-4').removeClass('col-md-4');
        $('.supporters .section-honor-roll .col-md-8').removeClass('col-md-8');
        $('.supporters .section-honor-roll .order-md-2').removeClass('order-md-2');
        $('.supporters .directors .col-md-12').addClass('col-md-10');
        $('.supporters .directors .col-md-12').addClass('offset-md-1');
        $('.supporters .directors .col-md-12').addClass('col-md-12');
        $('.supporters .global-inner .col-md-3').addClass('col-md-12');
        $('.supporters .global-inner .col-md-8').addClass('col-md-12');
        $('.supporters .global-inner .col-md-3').removeClass('col-md-3');
        $('.supporters .global-inner .col-md-3').removeClass('offset-md-1');
        $('.supporters .global-inner .col-md-8').removeClass('col-md-8');

        $('.financials .col-md-4').addClass('col-md-10');
        $('.financials .col-md-4').removeClass('col-md-4');
        $('.financials .col-md-6').addClass('col-md-10');
        $('.financials .col-md-6').removeClass('col-md-6');
        $('.financials .col-md-3').addClass('col-md-10');
        $('.financials .col-md-3').addClass('offset-md-1');
        $('.financials .col-md-3').removeClass('col-md-3');

        $('footer .col-sm-12.col-md-6').removeClass('col-md-6').addClass('col-md-12');


    }


    let swiperList = new Swiper('.list-wrapper .swiper', {
        //  width: "auto",
        slidesPerView: 3,
        loop: false,
        speed: 500,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            810: {
                slidesPerView: 3,
            }
        }

    })

    $('ul.contributors li').on('click', function() {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            hideList($(this).attr('data-list'));

        } else {
            if (!listopen) {
                $(this).addClass('active');
                showList($(this).attr('data-list'));
            } else {
                hideList(listopen);
                $('ul.contributors li').removeClass('active');
                $(this).addClass('active');
                showList($(this).attr('data-list'));
            }
        }
    });
}

const buildContributorsMobile = e => {

    $('.list-wrapper').each(function() {
        var html = $(this).prop('outerHTML');
        var list = $(this).attr('data-list');

        $('ul.contributors').find('li[data-list = ' + list + ' ]').after(html);
    });


}


const buildTesmonialsSlider = e => {
    let swiperTest = new Swiper('.section-testmonials .swiper', {
        //width: "auto",
        slidesPerView: 1,
        loop: false,
        speed: 500,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            810: {
                slidesPerView: 3,
            }
        }

    })
}


const showList = list => {
    $(".list-wrapper[data-list='" + list + "']").show();
    listopen = list;
}

const hideList = list => {
    $(".list-wrapper[data-list='" + list + "']").hide();
    listopen = false;

}


export default () => {
    build()
}